import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { User } from '../interfaces';
import { saveOrgInfoLocal } from '../globals';
import { getAuth, signOut } from 'firebase/auth';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  auth,
  db,
  initDataStoreGeneralSettings,
  initDataStoreOrgUser,
  initDataStorePublicSettings,
  initDataStoreRootUser,
  setPaidFunctionalities,
} from '../app.component';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-set-organisation',
  templateUrl: './set-organisation.component.html',
  styleUrls: ['./set-organisation.component.scss'],
})
export class SetOrganisationComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private permissionsService: PermissionsService,
  ) {}

  async ngOnInit() {
    // to set organisation use: /set-organisation/wemaron
    const orgId = this.route.snapshot.paramMap.get('orgId');
    if (orgId) {
      localStorage.setItem('orgId', orgId);
      await saveOrgInfoLocal(orgId);
      console.log('setting org:', orgId);
      auth.onAuthStateChanged(async (user) => {
        console.log('user', user);
        if (user) {
          const userRef = doc(db, `users/${user.uid}`);
          console.log('userRef', userRef.path);
          console.log('user uid', user.uid);
          let userData = (await getDoc(userRef)).data() as User;
          console.log('userData', userData);
          if (!userData) {
            userData = {};
          }
          if (!userData.organisations) {
            userData.organisations = [];
          }
          console.log('userData.organisations', userData.organisations);
          const userOrg = userData.organisations.find((x) => x.id === orgId);

          if (!userOrg?.roles || userOrg.roles.length === 0) {
            this.showSnackbar(
              'Het is niet mogelijk om als passagier in te loggen op de planomgeving.',
            );
            return this.signOutBackToLogin();
          }

          localStorage.setItem('accType', JSON.stringify(userOrg.roles));
          await setDoc(
            doc(db, `users`, `${user.uid}`),
            {
              selectedOrgId: orgId,
            },
            { merge: true },
          );

          await initDataStoreRootUser(user, this.iconRegistry, this.sanitizer);
          await initDataStorePublicSettings();
          await initDataStoreGeneralSettings();
          await initDataStoreOrgUser();
          await setPaidFunctionalities(orgId);

          console.log('userOrg', userOrg);
          this.router.navigate([this.permissionsService.getDefaultRoute(user.uid, userOrg.roles)]);
        } else {
          localStorage.setItem('refresh', '0');
          this.router.navigate(['/login']);
        }
      });
    }
  }

  signOutBackToLogin() {
    signOut(getAuth())
      .then(() => {
        return this.router.navigate(['/login']);
      })
      .catch((error) => {
        console.log('logoutError', error);
      });
  }

  showSnackbar(txt: string) {
    this.snackBar.open(txt, 'X', {
      duration: 5000,
    });
  }
}
